import * as React from "react";
import Lead from "../../../model/lead/Lead";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import RemovableList from "../../../hiberUiKit/src/molecules/RemovableList/RemovableList";
import {Option} from "ts-option";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import * as _ from "underscore";
import CreatableSearchDropDown from "../../../hiberUiKit/src/molecules/SearchDropDown/CreatableSearchDropDown";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import Tag from "../../../model/tag/Tag";
import {Dispatch} from "redux";
import Toast from "../../helper/Toast";
import User from "../../../model/user/User";
import {setTags} from "../../../store/action/lead/lead";

interface ComponentProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface IReduxProps {
	/**
	 * Tags
	 */
	tags: Tag[]
	/**
	 * Logged in user detail
	 */
	user: User
}

interface IDispatchProps {
	/**
	 * Add tag to lead action
	 * @param {string} leadId
	 * @param {string} tagName
	 */
	setTags: (leadId: string, tags: Tag[]) => void
}


interface IState {
	dropDownVisible: boolean;
}

type Props = ComponentProps & IReduxProps & IDispatchProps

class Tags extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {dropDownVisible: false};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.onRemove = this.onRemove.bind(this);
	}

	render() {
		const selectedTags = this.props.lead.map(l => l.tags).getOrElse([]);
		const tagsString = _.difference(this.props.tags.map(t => t.name), selectedTags.map(t => t.name));
		const tags = tagsString.map(t => new Tag(t));
		return (
			//TODO Change icon
			<InfoModule icon={Icon.New}
						title={"TAGS"}
						actionIcon={Icon.Add}
						onActionIconClick={this.toggleDropdown}>

				{this.state.dropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({dropDownVisible: false})}>
					<CreatableSearchDropDown items={tags}
											 onSelect={this.onSelect}
											 itemToLabel={(tag: Tag) => tag.name}
											 itemToId={(tag: Tag) => tag.name}
						//TODO change icon
											 searchInputIcon={Icon.New}
											 newOptionCreator={(text) => new Tag(text)}
											 creatable={true}/>
				</DropDownWrapper>
				}
				{
					selectedTags.length ?
						<RemovableList items={selectedTags}
									   itemRowRenderer={(item: Tag) => item.name}
									   onRemove={this.onRemove}/> :
						<span className="t-body">No tags</span>
				}
			</InfoModule>
		);
	}

	toggleDropdown() {
		this.setState({dropDownVisible: !this.state.dropDownVisible});
	}

	onSelect(tag: Tag) {
		this.toggleDropdown();
        this.props.lead.map(l => l.tags.map(t => t.name == tag.name)
            .some(tagExists => tagExists) ? null : this.props.setTags(l.id, l.tags.concat(tag)));
	}

	onRemove(tag: Tag) {
		this.props.lead.map(l => {
			const updatedTags = l.tags.filter(t => t.name != tag.name);
			this.props.setTags(l.id, updatedTags);
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		setTags: (leadId: string, tags: Tag[]) => dispatch(
			setTags(leadId, tags,
				() => {Toast.success("Lead tags updated", "Tags update")},
				() => {Toast.error("Sorry, something went wrong. Try again later.", "Tags update")}))
	}
}

function mapStateToProps(state: RootState) {
	return {
		tags: state.lead.tags.getOrElse([]),
		user: state.user.user.get
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Tags)